function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomecareAndIndustrialCleaning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.94,210.59a4,4,0,0,0-.86-2.4L153,172.45l-10.34-35.2a4,4,0,1,0-7.67,2.25l10.55,35.94a3.87,3.87,0,0,0,.7,1.35L174,212.09l0,1.61H144.38a11.72,11.72,0,0,0-11.71,11.71v37.12a11.71,11.71,0,0,0,11.71,11.71h30.1A11.27,11.27,0,0,1,163.72,282H110.55a11.46,11.46,0,0,1-11.41-11.22L98.22,215l15.39-75.85a4,4,0,0,0-7.84-1.59L90.3,213.86a4.12,4.12,0,0,0-.09.86l.93,56.14A19.49,19.49,0,0,0,110.55,290h53.17a19.39,19.39,0,0,0,19.4-19.69,0,0,0,0,0,0,0v-.08Zm-37.56,55.65h0a3.72,3.72,0,0,1-3.71-3.71V225.41a3.72,3.72,0,0,1,3.71-3.71h29.78l.89,44.53Zm64-130.8a4,4,0,0,0-5.65.22c-.77.83-18.87,20.74-25.56,54.38a4,4,0,0,0,3.15,4.7,3.44,3.44,0,0,0,.78.08,4,4,0,0,0,3.92-3.22c6.23-31.32,23.42-50.33,23.59-50.51A4,4,0,0,0,208.41,135.44Zm59.4,20.66A128.69,128.69,0,0,0,242,134.93a4,4,0,1,0-4,6.9c.47.28,47.79,28.59,47.79,72.76l-.91,55.11a3.08,3.08,0,0,0,0,.61A11.41,11.41,0,0,1,273.44,282H195.12a4,4,0,0,0,0,8h78.32a19.41,19.41,0,0,0,19.4-18.69c0-.13,0-.26,0-.4l.93-56.21C293.79,194.34,284.8,174.09,267.81,156.1Zm-5.06,95.28a17,17,0,0,0,17-17V207.8a17,17,0,0,0-17-17h-1.31a17,17,0,0,0-17,17v26.62a17,17,0,0,0,17,17Zm-10.27-17V207.8a9,9,0,0,1,9-9h1.31a9,9,0,0,1,9,9v26.62a9,9,0,0,1-9,9h-1.31A9,9,0,0,1,252.48,234.42Z",
    style: {
      fill: "#9da0a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.87,138.36a4,4,0,0,0-8,0,46.05,46.05,0,0,0,15.49,32.13,4,4,0,1,0,5.31-6A38.68,38.68,0,0,1,159.87,138.36Zm27.34-34.61-13.24-4a4,4,0,0,0-2.3,7.66l10.39,3.12v2l-10.43,3.24a4,4,0,0,0,1.19,7.82,4.09,4.09,0,0,0,1.19-.18l13.24-4.12a4,4,0,0,0,2.81-3.82v-7.94A4,4,0,0,0,187.21,103.75ZM164,125.06v-27a4,4,0,0,0-4-4H114.46a17,17,0,0,0-17,17v14a4,4,0,0,0,4,4H160A4,4,0,0,0,164,125.06Zm-8-4H105.5V111a9,9,0,0,1,9-9H156Z",
    style: {
      fill: "#f5882a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,94.05H216a17,17,0,0,0-17,17v14a4,4,0,0,0,4,4H241a4,4,0,0,0,4-4V111A17,17,0,0,0,228,94.05Zm9,27H207.06V111a9,9,0,0,1,9-9h12a9,9,0,0,1,9,9Z",
    style: {
      fill: "#2ba6de"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomecareAndIndustrialCleaning);
export default __webpack_public_path__ + "static/media/homecare-and-industrial-cleaning.f32af7b2e2e3032f9b7d2787fae94e18.svg";
export { ForwardRef as ReactComponent };